<template>
  <div class="left-sidebar" :class="{ 'in-drawer': inDrawer }">
    <!-- 导航菜单 -->
    <div class="nav-list">
      <!-- 首页Agent -->
      <div class="nav-item" :class="{ active: menuActive === 1 }" @click="clickMenu({ id: 1, title: '首页Agent', isFolder: false })">
        <i class="el-icon-lightning"></i>
        <span>首页Agent</span>
      </div>

      <!-- =====电商图设计 带下拉文件夹【isFolder:true】===== -->
      <div class="menu-group">
        <div class="nav-item" :class="{ active: menuActive === 2 }" @click="clickMenu({ id: 2, title: '电商图设计', isFolder: true })">
          <i class="el-icon-video-camera"></i>
          <span>电商图设计</span>
        </div>
        <div v-show="showSubMenuEcommerce" class="sub-menu-wrap">
          <div class="sub-nav-item" :class="{ active: subActive === sub.id }" v-for="sub in subMenuEcommerceList" :key="sub.id" @click.stop="clickSubMenu(sub)">
            <span>{{ sub.title }}</span>
          </div>
        </div>
      </div>

      <!-- =====AI工具 带下拉文件夹【isFolder:true】===== -->
      <div class="menu-group">
        <div class="nav-item" :class="{ active: menuActive === 3 }" @click="clickMenu({ id: 3, title: 'AI工具', isFolder: true })">
          <i class="el-icon-folder-opened"></i>
          <span>AI工具</span>
        </div>
        <div v-show="showSubMenuAi" class="sub-menu-wrap">
          <div class="sub-nav-item" :class="{ active: subActive === sub.id }" v-for="sub in subMenuAiList" :key="sub.id" @click.stop="clickSubMenu(sub)">
            <span>{{ sub.title }}</span>
          </div>
        </div>
      </div>

      <!-- 我的任务 -->
      <div class="nav-item" :class="{ active: menuActive === 4 }" @click="clickMenu({ id: 4, title: '我的任务', isFolder: false })">
        <i class="el-icon-picture-outline"></i>
        <span>我的任务</span>
      </div>
    </div>

    <!-- 底部会员 【固定不滚动区域】 -->
    <div class="sidebar-bottom">
      <div class="bottom-item" @click="myOrder">
        <i class="el-icon-tickets"></i>
        <span>我的订单</span>
      </div>
      <div class="bottom-item" @click="zichan">
        <i class="el-icon-set-up"></i>
        <span>我的资产</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    inDrawer: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      subMenuEcommerceList: [
        { id: 101, title: '商品主图', path: '/zhutu' },
        { id: 102, title: 'A+详情', path: '/xiangqing' },
        { id: 103, title: '爆款图复刻', path: '/baokuan' }
      ],
      subMenuAiList: [
        { id: 201, title: '一键抠图', path: '/koutu' },
        { id: 202, title: '商品精修', path: '/jingxiu' }
      ],
      menuActive: 1,
      showSubMenuEcommerce: false,
      showSubMenuAi: false,
      subActive: null
    }
  },
  watch: {
    // 路由一变，自动刷新侧边栏选中状态
    '$route.path'(newPath) {
      this.setActiveByPath(newPath)
    }
  },
  mounted() {
    // 页面刷新进来，根据当前路由初始化高亮
    this.setActiveByPath(this.$route.path)
  },
  methods: {
    // 核心方法：根据路由路径自动设置高亮、展开子菜单
    setActiveByPath(path) {
      // 重置
      this.subActive = null
      this.menuActive = null

      // ---------电商图子菜单匹配
      const ecommerceItem = this.subMenuEcommerceList.find((item) => item.path === path)
      if (ecommerceItem) {
        this.menuActive = 2
        this.subActive = ecommerceItem.id
        this.showSubMenuEcommerce = true
        this.showSubMenuAi = false
        return
      }

      // ---------AI工具子菜单匹配
      const aiItem = this.subMenuAiList.find((item) => item.path === path)
      if (aiItem) {
        this.menuActive = 3
        this.subActive = aiItem.id
        this.showSubMenuAi = true
        this.showSubMenuEcommerce = false
        return
      }

      // --------一级菜单
      if (path === '/index') {
        this.menuActive = 1
        this.showSubMenuEcommerce = false
        this.showSubMenuAi = false
      } else if (path === '/task') {
        this.menuActive = 4
        this.showSubMenuEcommerce = false
        this.showSubMenuAi = false
      } else if (path === '/zichan') {
        // 资产页面不高亮上面导航
        this.menuActive = null
        this.showSubMenuEcommerce = false
        this.showSubMenuAi = false
      } else if (path === '/myorder') {
        // 订单页面不高亮上面导航
        this.menuActive = null
        this.showSubMenuEcommerce = false
        this.showSubMenuAi = false
      }
    },

    clickMenu(menu) {
      // =========文件夹菜单只展开收起=========
      if (menu.isFolder) {
        if (menu.id === 2) {
          this.showSubMenuAi = false
          this.showSubMenuEcommerce = !this.showSubMenuEcommerce
        }
        if (menu.id === 3) {
          this.showSubMenuEcommerce = false
          this.showSubMenuAi = !this.showSubMenuAi
        }
        return
      }

      // 一级菜单跳转
      this.menuActive = menu.id
      this.showSubMenuEcommerce = false
      this.showSubMenuAi = false

      if (menu.title === '首页Agent') {
        this.$router.push('/index')
      } else if (menu.title === '我的任务') {
        this.$router.push('/task')
      }
    },

    clickSubMenu(subItem) {
      this.subActive = subItem.id
      this.$router.push(subItem.path)
    },

    zichan() {
      this.$router.push('/zichan')
      this.showSubMenuEcommerce = false
      this.showSubMenuAi = false
    },

    myOrder() {
      this.$router.push('/myorder')
      this.showSubMenuEcommerce = false
      this.showSubMenuAi = false
    }
  }
}
</script>

<style scoped>
.left-sidebar {
  width: 100px;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  background: #ffffff;
  border-right: 1px solid #f1f1f1;
  padding: 20px 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  /* 高于页面底部悬浮输入条(z-index:100)，避免「我的订单 / 我的资产」被遮住 */
  z-index: 200;
}
.left-sidebar.in-drawer {
  position: static;
  height: 100%;
  border-right: none;
  width: 100%;
  overflow-y: auto;
}

.nav-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 26px;
  width: 100%;
  /* 菜单过多（展开子菜单）时自身滚动，【核心修复：只让上面菜单区域滚动，底部固定不动】 */
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
  padding-bottom:10px;
}

.menu-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.nav-item {
  width: 90px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #666;
  cursor: pointer;
  position: relative;
  box-sizing: border-box;
}
.in-drawer .nav-item {
  width: 90%;
  flex-direction: row;
  gap: 8px;
}
.in-drawer .sub-menu-wrap {
  width: 90%;
}
.in-drawer .sub-nav-item {
  text-align: left;
  padding-left: 24px;
}

.nav-item.active {
  background-color: #f0f9fe;
  color: #22b8e6;
}
.nav-item:hover {
  background-color: #f7f9fb;
  color: #22b8e6;
}

.sub-menu-wrap {
  width: 90px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.sub-nav-item {
  font-size: 11px;
  color: #888;
  text-align: center;
  padding: 4px 2px;
  cursor: pointer;
  border-radius: 6px;
}
.sub-nav-item:hover {
  background: #f7f9fb;
  color: #22b8e6;
}
.sub-nav-item.active {
  background-color: #f0f9fe;
  color: #22b8e6;
}

/* =========【核心修复】底部区域固定，不被撑开挤走 ========= */
.sidebar-bottom {
  flex-shrink: 0;
  margin-top: 12px;
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 2;
  background: #ffffff;
}
.in-drawer .sidebar-bottom {
  width: 90%;
}
.bottom-item {
  font-size: 12px;
  color: #666;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  margin-top: 10px;
  flex-shrink: 0;
  width: 90px;
  box-sizing: border-box;
}
.in-drawer .bottom-item {
  width: 100%;
  flex-direction: row;
  gap: 8px;
}
.bottom-item span {
  color: #666;
  text-align: center;
  white-space: nowrap;
}
.bottom-item i {
  font-size: 18px;
  margin-bottom: 4px;
}
.in-drawer .bottom-item i {
  margin-bottom: 0;
}
</style>
